import styled from '@emotion/styled';
import * as React from 'react';
import { theme } from '../../theme';
const StyledList = styled.ul `
	margin: 0;
	padding: 0;
	list-style: none;
`;
const StyledListItem = styled.li `
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	outline: none;

	&:hover,
	&:active,
	&:focus {
		background-color: ${theme.colors.LM_NU20};
	}

	border-top: 1px solid rgba(5, 42, 128, 0.1);

	/* borders touching container are always transparent */
	&:last-child {
		border-bottom: 1px solid transparent;
	}
	&:first-of-type {
		border-color: transparent;
	}
`;
const StyledListText = styled.span `
	display: block;
	flex-grow: 1;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	${theme.typography.IR90};
`;
const Option = ({ option, onSelect, index }) => {
    return (React.createElement(StyledListItem, { tabIndex: 0, onClick: () => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            onSelect(option);
        }, "data-testid": `autocomplete-option-${index}` },
        React.createElement(StyledListText, null, option.label)));
};
export const OptionList = ({ options, onSelect }) => {
    if (!options || !options.length)
        return null;
    return (React.createElement("div", { className: "option-list" },
        React.createElement(StyledList, { "data-testid": "autocomplete-options" }, (options || []).map((o, i) => (React.createElement(Option, { key: i, option: o, index: i, onSelect: onSelect }))))));
};
//# sourceMappingURL=OptionList.js.map